import demote from 'browser-demote';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

demote.use({
    refuse:['box-sizing', 'border-radius','transform'],
    continueFunction:function(){
        ReactDOM.render(<App />, document.getElementById('root'));
        registerServiceWorker();
    }
});

if(!demote.status().isShow) {
    ReactDOM.render(<App />, document.getElementById('root'));
    registerServiceWorker();
}




// WEBPACK FOOTER //
// ./src/index.js